import styles from './Loading.module.scss';

import type { FC } from 'react';

export type Props = {
  loading: boolean;
};

export const Loading: FC<Props> = ({ loading }) => (
  <>
    {loading ? (
      <div className={styles.wrap}>
        <div className={styles['loading-object']}>
          <div className={styles['loading-object-inner']}>
            <div className={styles.metronome}>
              <div className={styles['metronome-dot']}></div>
              <div className={styles['metronome-dot']}></div>
              <div className={styles['metronome-dot']}></div>
              <div className={styles['metronome-dot']}></div>
            </div>
            <span className={styles['loading-text']}>通信中...</span>
          </div>
        </div>
      </div>
    ) : (
      ''
    )}
  </>
);
